module.exports = __webpack_public_path__ + "static/media/guillaume-de-germain-fgmLRBlUIpc_large.d046a078.jpg";